/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';

// @ts-expect-error untyped dependency

// @ts-expect-error untyped dependency

import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import PlanCompatibilityMessage from 'marketplace-ui-common/compatibility/components/PlanCompatibilityMessage';

// @ts-expect-error untyped dependency
import { makeGetRequiredPlansForFeatures } from '../../../../selectors/details';
// @ts-expect-error untyped dependency
import { getFeatureCompatibilityRequestState } from '../../../../selectors/requestStates';
// @ts-expect-error untyped dependency
import { getIsUngatedForContentHub } from '../../../../selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
const getI18nKey = key => `appMarketplace.detail.overview.sidebar.requirements.${key}`;
const PlanCompatibility = ({
  integrationFeatures,
  installability,
  isCustomer,
  isOpsHubListing,
  onOpenFeatureCompatibilityModal,
  tiers,
  trackInteraction
}) => {
  const {
    hubInstallable,
    nonTrialHubInstallable
  } = installability || {};
  const isUngatedForContentHub = useSelector(getIsUngatedForContentHub);
  const getRequiredPlans = useMemo(makeGetRequiredPlansForFeatures, []);
  const requiredPlans = useSelector(state => getRequiredPlans(state, integrationFeatures));
  const featureCompatibilityStatus = useSelector(getFeatureCompatibilityRequestState);
  const compatibilityType = useMemo(() => {
    if (!isOpsHubListing || !requiredPlans) {
      return 'COMPATIBLE_ALL';
    }
    // @ts-expect-error plan type is undefined
    const missingRequiredPlans = requiredPlans.filter(plan => !!plan);
    if (missingRequiredPlans.size === 0) {
      return 'COMPATIBLE_ALL';
    } else if (integrationFeatures && missingRequiredPlans.size <= integrationFeatures.size / 2) {
      return 'COMPATIBLE_MOST';
    } else if (!hubInstallable) {
      return 'COMPATIBLE_NONE';
    } else {
      return 'COMPATIBLE_SOME';
    }
  }, [hubInstallable, requiredPlans, isOpsHubListing, integrationFeatures]);
  const opsHubLoadingStatus = isOpsHubListing ? featureCompatibilityStatus : RequestState.SUCCEEDED;
  const pageLoadingStatus = !installability ? RequestState.PENDING : opsHubLoadingStatus;
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: pageLoadingStatus,
    children: /*#__PURE__*/_jsx(PlanCompatibilityMessage, {
      appContext: isCustomer ? 'app' : 'public',
      compatibilityType: compatibilityType,
      helpText: compatibilityType !== 'COMPATIBLE_ALL' ? /*#__PURE__*/_jsx(UIHelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getI18nKey('compatibilityDisclaimer')
        })
      }) : undefined,
      isUngatedForContentHub: isUngatedForContentHub,
      nonTrialHubInstallable: nonTrialHubInstallable,
      onTrackInteraction: trackInteraction,
      onFeaturesLinkClick: () => onOpenFeatureCompatibilityModal(),
      showCompatiblePlansLink: !isOpsHubListing,
      tiers: tiers
    })
  });
};
export default PlanCompatibility;